const mutations = {
  SET_APARTS(state, payload){
    payload = payload.map(a => {a.balance = Number(a.balance); return a});

    state.all = payload;

    let groups = [];

    let indexInGroup = (id) => {
      return groups.findIndex(g => g.id === id);
    };

    payload.forEach(apart => {
      let building = apart.address[0];
      if(indexInGroup(building.id) === -1){
        let group = {
          id: building.id,
          isGroup: true,
          name: building.address,
          aparts: [],
        };
        groups.push(group);
      }
      let groupIndex = indexInGroup(building.id);
      groups[groupIndex].aparts.push(apart);
    });
    state.allInGroups = groups;
  },
  SET_SELECTED(state, payload){
    state.selected = payload;
  },
  SET_SEND_CHARGE_EMAIL(state, {value, apart}){
    let apartIndex = state.all.findIndex(a => a.account_number === apart.account_number);
    state.all[apartIndex].send_charge_email = value;
  },
  SET_OWNERS(state, payload){
    state.owners = payload;
  },
  SET_LE_INFO(state, le_info){
    state.leInfo = le_info;
  }
};

export default mutations;
